import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintborn = () => {
  const title = "{BRAND.short} is born - the origin story {BRAND.short} is born in the first published April 2024 - The app and graphic novels are the beginning of a movement and rebellion for a safer space online."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on March, 2023</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel} came to life through The Buddyhood's debut novel in
                The Unfollow Series, <em>The Dark Side of Food</em>. Through
                this powerful new series, The Buddyhood aims to tell stories
                that spark positive change and challenge &lsquo;mental
                pollution&rsquo;—the toxic trends that flood our lives with
                negativity and unrealistic expectations, particularly through
                social media and pop culture.
              </p>

              <p>
                This mental pollution can lead to anxiety, low self-esteem, and
                a distorted sense of self. In contrast, The Buddyhood&apos;s
                storytelling is rooted in empowerment, encouraging readers to
                embrace their true selves and lead more fulfilling lives.
              </p>

              <p>
                Driven by the same vision, {BRAND.domainLabel} was created as an
                alternative future for social networking, one designed from the
                ground up with mental well-being in mind. Prioritising safety by
                design, {BRAND.domainLabel} offers an alternative space for young
                adults online in a space often dominated by harmful algorithms
                and online abuse.
              </p>

              <p>
                As social media algorithms, misinformation, and trolling
                continue to fuel a mental health crisis, the consequences are
                becoming impossible to ignore. In the UK, this crisis is not
                only costing taxpayers millions but also placing immense
                pressure on NHS resources and, tragically, contributing to lives
                lost.
              </p>

              <p>
                {BRAND.domainLabel} aims to retain the positive aspects of digital
                connection and expression while eliminating the harm. It stands
                as a bold alternative, championing a movement for a better,
                safer online world.
              </p>

              <p>
                Both The Unfollow Series and {BRAND.domainLabel} mark the beginning of
                a cultural shift toward more inclusive, supportive online spaces
                and storytelling. Together, they aim to build a future where
                people are free to be themselves and connect without fear, both
                in the real world and online.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintborn;
